export default function getScrollbarWidth() {
  return window.innerWidth - document.documentElement.offsetWidth;
}
